import { Injectable } from '@angular/core';
import { DatabaseHelper } from 'database-builder';

@Injectable()
export class DatabaseHelperService extends DatabaseHelper {

}
